/* eslint-disable prettier/prettier */
export const CompanyTableHeader = () => (
  <div className="flex items-center px-4 py-3 font-semibold border text-md sm:w-[90%] bg-gray-50 text-muted-foreground">
    <div className="w-[55%] sm:w-[40%] sm:ml-12">Company</div>
    <div className="w-[40%] sm:w-[20%] sm:ml-[-48px]">Country</div>
    <div className="hidden sm:w-[20%]  sm:block">Users</div>
    <div className="hidden sm:w-[10%] sm:block">Status</div>
    <div className="w-[5%] sm:w-[10%]"></div>
  </div>
);
